const F1Logo = ({ className = '', height = '1em', color = '#E10600', ariaLabel = 'Formula 1' }) => (
  <svg
    role="img"
    viewBox="0 9 24 6"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    height={height}
    className={className}
    aria-label={ariaLabel}
    style={{ display: 'inline-block' }}
  >
    <title>{ariaLabel}</title>
    <path d="M9.6 11.24h7.91L19.75 9H9.39c-2.85 0-3.62.34-5.17 1.81C2.71 12.3 0 15 0 15h3.38c.77-.75 2.2-2.13 2.85-2.75.92-.87 1.37-1.01 3.37-1.01zM20.39 9l-6 6H18l6-6h-3.61zm-3.25 2.61H9.88c-2.22 0-2.6.12-3.55 1.07C5.44 13.57 4 15 4 15h3.15l.75-.75c.49-.49.75-.55 1.78-.55h5.37l2.09-2.09z" />
  </svg>
)

export default F1Logo
